export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div>
          <div className="footer-brand">↗ <span>Natural<br />Packers & Movers</span></div>
          <p>Your trusted moving partner for a safer, smoother and stress-free relocation experience.</p>
          <div className="socials"><span>f</span><span>◎</span><span>in</span><span>▶</span></div>
        </div>
        <div>
          <h4>Quick Links</h4>
          <a href="#">Home</a><a href="#">Services</a><a href="#">Get Quote</a><a href="#">Blogs</a><a href="#">About Us</a><a href="#">Contact</a>
        </div>
        <div>
          <h4>Our Services</h4>
          <a href="#">Residential Moving</a><a href="#">Commercial Relocation</a><a href="#">Vehicle Transportation</a><a href="#">Long-Distance Moving</a><a href="#">Storage & Warehousing</a><a href="#">Packing & Unpacking</a>
        </div>
        <div>
          <h4>Contact Us</h4>
          <p>📍 Chennai, Tamil Nadu, India</p>
          <p>📞 +91 98765 43210</p>
          <p>✉ info@naturalpackersandmovers.com</p>
          <p>◷ Mon - Sun: 8:00 AM - 8:00 PM</p>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2026 Natural Packers & Movers. All rights reserved.</span>
        <span>Terms & Conditions &nbsp; | &nbsp; Privacy Policy &nbsp; | &nbsp; Sitemap</span>
      </div>
    </footer>
  );
}
